export default "__VITE_ASSET__18329cab__"